import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Modal, Typography } from "@parkschannel/ui";
import { useAdvisorModal } from "./AdvisorModalContext";
import classNames from "classnames";
import { ImgixImage } from "../../../ImgixImage";
export const AdvisorModal = ()=>{
    const { advisor , setAdvisor  } = useAdvisorModal();
    if (!advisor) return null;
    return /*#__PURE__*/ _jsx(Modal, {
        isOpen: !!advisor,
        setIsOpen: ()=>setAdvisor(null),
        contentClassName: classNames("h-screen max-w-[700px] md:h-auto overflow-y-auto"),
        children: /*#__PURE__*/ _jsxs("div", {
            className: "h-full mt-10 pb-6 md:pl-1",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "h-[250px] w-full relative rounded-xl mb-4 md:w-[250px] md:float-left md:mr-6",
                    children: /*#__PURE__*/ _jsx(ImgixImage, {
                        src: advisor.avatar_key,
                        alt: advisor.name,
                        fill: true,
                        className: "object-cover md:object-contain"
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "mb-4",
                    children: [
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: "h4",
                            component: "h3",
                            className: "text-neutral-900",
                            children: advisor.name
                        }),
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: "bodyBase",
                            className: "text-neutral-700",
                            children: advisor.shortDescription
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    variant: "bodyLarge",
                    className: "whitespace-pre-wrap text-neutral-700",
                    children: advisor.description
                })
            ]
        })
    });
};
